import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "user-management",
  "use": "user-management-usage",
  "viewBox": "0 0 22 20",
  "content": "<symbol viewBox=\"0 0 22 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"user-management\"><path clip-rule=\"evenodd\" d=\"M7.25 10a3.437 3.437 0 100-6.875 3.437 3.437 0 000 6.875z\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path d=\"M1.625 16.875a5.625 5.625 0 0111.25 0M12.876 3.68a3.438 3.438 0 11-.005 5.762M13.5 11.39a5.631 5.631 0 016.875 5.485\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/user-management.svg
// module id = eBgY
// module chunks = 39 44